module.exports = __webpack_public_path__ + "img/yikoujia.ec7db465.png";